import React from 'react';
import { useDeals } from '../context/DealsContext';

const QualityTrends = () => {
  const { deals } = useDeals();

  const qualityByStage = deals.reduce((acc, deal) => {
    if (!acc[deal.stage]) {
      acc[deal.stage] = { total: 0, count: 0 };
    }
    acc[deal.stage].total += deal.qualityScore;
    acc[deal.stage].count += 1;
    return acc;
  }, {});

  const avgQualityByStage = Object.keys(qualityByStage)
    .map(stage => ({
      stage,
      avgQuality: qualityByStage[stage].total / qualityByStage[stage].count,
      count: qualityByStage[stage].count
    }))
    .sort((a, b) => b.avgQuality - a.avgQuality);

  const getQualityColor = (score) => {
    if (score >= 8) return 'bg-green-500 dark:bg-green-500';
    if (score >= 6) return 'bg-yellow-500 dark:bg-yellow-500';
    return 'bg-red-500 dark:bg-red-500';
  };

  return (
    <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">Quality by Stage</h3>
      <div className="space-y-4">
        {avgQualityByStage.map((item) => (
          <div key={item.stage} className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium text-gray-700 dark:text-gray-300">{item.stage}</span>
              <div className="flex items-center space-x-2">
                <span className="text-sm text-gray-500 dark:text-gray-400">({item.count} deals)</span>
                <span className="text-sm font-medium text-gray-900 dark:text-gray-200">
                  {item.avgQuality.toFixed(1)}/10
                </span>
              </div>
            </div>
            <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
              <div 
                className={`h-2 rounded-full ${getQualityColor(item.avgQuality)}`} 
                style={{ width: `${(item.avgQuality / 10) * 100}%` }} 
              />
            </div>
          </div>
        ))}
      </div>
      {avgQualityByStage.length === 0 && (
        <div className="text-center py-8 text-gray-500 dark:text-gray-400">
          No data available
        </div>
      )}
    </div>
  );
};

export default QualityTrends;